import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { translate } from 'modules/contracts/lib/translate'
import { ContractFieldsProps } from 'modules/contracts/lib/types'

interface Props {
  form: Form
  translations: { [key: string]: string }
  professionalCategories: ContractFieldsProps[]
}

const categoriesToOrderedOptions = (professionalCategories: ContractFieldsProps[]) => {
  return [...categoriesToOptions(professionalCategories)].sort((a, b) =>
    a.label.localeCompare(b.label)
  )
}

const categoriesToOptions = (professionalCategories: ContractFieldsProps[]) =>
  professionalCategories
    .filter((value) => value.archivedAt === null)
    .map((category) => ({
      value: category.id,
      label: category.name,
    }))

const ProfessionalCategory = ({ form, translations, professionalCategories }: Props) => {
  const options = categoriesToOrderedOptions(professionalCategories)

  const name = () => {
    const id = form.get('es_professional_category_id').value
    const option = options.find((e) => String(e.value) === String(id))
    return option ? option.label : `-- ${i18n.t('common.none')} --`
  }

  const labelNotFound = () => {
    return options.length
      ? i18n.t(
          'contract_versions.forms.contract_extra_information.a3innuva.professional_category_not_found'
        )
      : i18n.t(
          'contract_versions.flows.fix.steps.legal_and_extras.professional_category.empty_state_text'
        )
  }

  return (
    <DropdownSearchBar
      name={name()}
      label={translate(translations, 'professional_category') || ''}
      onSelect={(item) => {
        form.setValues({
          es_professional_category_id: item.value,
        })
      }}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      popoverWidth="s400"
    />
  )
}
export default observer(ProfessionalCategory)
